import {MutationTree} from 'vuex'
import {AuthorizationState, initialState} from '@/store/modules/authorization'

interface TokensPayload {
    accessToken: string
    refreshToken: string
}

export const mutations: MutationTree<AuthorizationState> = {

    setAccessToken: (state, token: string) => {
        state.accessToken = token
    },

    setRefreshToken: (state, token: string) => {
        state.refreshToken = token
    },

    setTokens: (state, tokens: TokensPayload) => {
        state.accessToken = tokens.accessToken
        state.refreshToken = tokens.refreshToken
    },

    resetState: (state) => {
        state = Object.assign(state, initialState())
    }
}